import { Link, useLocation, useNavigate } from "react-router-dom"
import { DropDownButton } from "devextreme-react"
import { BreadcrumbHelper } from "./breadcrumbHelper"
import { useScreenSize } from "../../hook/useScreenSize"
import { routes } from "../../navigation/appRoutes"
import { useTranslation } from "react-i18next"

export default function Breadcrumb() {
    const location = useLocation()
    const navigate = useNavigate()
    const { isXSmall } = useScreenSize()
    const { t } = useTranslation()
    const pathnames = location.pathname.split("/").filter((x) => x)

    const breadcrumbs = pathnames.map((_, index) => {
        const path = `/${pathnames.slice(0, index + 1).join("/")}`
        const matchingRoute = BreadcrumbHelper.matchRoute(path, routes)

        return matchingRoute ? {
            path: matchingRoute.resolvedPath,
            text: t(matchingRoute.route.breadcrumb)
        }
        : undefined
    })

    const getBreadcrumbLinks = (items: ({ path: string, text: string } | undefined)[]) => {
        return items.filter(item => item !== undefined)
            .map((item, index) => {
                return <li key={item!.path}>
                    <Link to={item!.path}>{item!.text}</Link>
                </li>
            })
    }

    return (
        <>
            { isXSmall ? <DropDownButton
                style={{ borderRadius: "1rem"}}
                className="icon-white"
                dropDownOptions={{ width: 200 }}
                icon="chevrondoubleright"
                activeStateEnabled
                stylingMode="text"
                items={breadcrumbs}
                onItemClick={(e) => {
                    navigate(e.itemData.path)
                    e.event?.stopPropagation()
                }}
                displayExpr="text"
                keyExpr="path" />
            : <div className="breadcrumbs">
                <nav>
                    <ol>
                        {getBreadcrumbLinks(breadcrumbs)}
                    </ol>
                </nav>
            </div> }
        </>
    )
}
